import React from "react";
import './footer.css' 

const Footer = () => {
  return (
    <>
      <footer className="footerStyle">
        <div className="bg-dark text-light py-3">
          <p className="text-center">
            Copyright &copy; MUSCLE FITNESS PVT . LTD
            </p>
        </div>
      </footer>
    </>
  );
};
export default Footer;